import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FlatpickrOptions } from 'ng2-flatpickr';
import { applicationFrom } from '../../../auth/models/commonEnum';

@Component({
	selector: 'app-hydroen-application',
	templateUrl: './hydroen-application.component.html',
	styleUrls: ['./hydroen-application.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class HydroenApplicationComponent implements OnInit {
	public contentHeader;
	applicationList: number;

	constructor() {}

	public sanctionDate: FlatpickrOptions = {
		altInput: true
	};
	public PRdate: FlatpickrOptions = {
		altInput: true
	}
	ngOnInit(): void {
		this.applicationList = applicationFrom.MY_APPLICATION;
		this.contentHeader = {
			headerTitle: 'Hydrogen Energy Applications',
			actionButton: true,
			breadcrumb: {
				type: '',
				links: [
					{
						name: 'Hydrogen Energy Applications',
						isLink: true,
						link: '/hydrogen-energy-application'
					},
				]
			}
		};
	}
}

